import { Grabber } from "./global-select-handler"
import { toWordSelectionPoint, WordBoxRange, type WordSelectionPoint } from "./wordbox"

/**
 * Dragger is responsible for "pinning" one of the start or end
 * nodes so that start and end inverts when the client moves their
 * mouse over the pinned point. This is meant to be very transient,
 * only alive so long as the user is dragging
 */
export class PinnedDragger {
    constructor(public pinnedBox: WordSelectionPoint, public freeBox: WordSelectionPoint) {}

    static fromWordBox(box : WordSelectionPoint) {
        return new PinnedDragger(box, box)
    }

    static fromRange(range : WordBoxRange, pin: Grabber) {
        return new PinnedDragger(
          toWordSelectionPoint(pin === Grabber.RIGHT ? range.start : range.end),
          toWordSelectionPoint(pin === Grabber.RIGHT ? range.end : range.start)
        )
    }

    updateBox(newBox: WordSelectionPoint) {
        this.freeBox = newBox
    }

    /**
     * We have to determine how it works for pinning things
     * @returns null if there is no range to go
     */
    getRange() : WordBoxRange | null {
        return WordBoxRange.fromPoints(this.freeBox, this.pinnedBox)
    }
}
